export default __webpack_public_path__ + "static/Privacy-Notice_EGIB_MY-cd1fffbe89cb1ec4b0e01133b655aa46.pdf";